'use client';

/* eslint-disable react/no-danger */

import { Accordion } from '@ngg/components';
import xss from 'xss';

import Icon from './icon';

export default function Description({
    title,
    description,
    className,
}: {
    title: string;
    description: string;
    className?: string;
}) {
    return (
        <Accordion
            IconComponent={Icon}
            WrapperComponent="div"
            transitionProps={{ appear: false }}
            classNames={{
                wrapper: className,
                button: 'text-left items-center leading-4 p-4 font-medium rounded-none',
                panel: 'p-4',
            }}
            title={title}
            defaultOpen>
            <div
                className="text-sm"
                dangerouslySetInnerHTML={{
                    __html: xss(description),
                }}
            />
        </Accordion>
    );
}
